import {
  FlaskConical,
  BarChart3,
  LayoutDashboard,
  Package,
  BookOpen,
  Radar,
} from "lucide-react";
import { RoutePath } from "@/routes";

export interface NavItem {
  title: string;
  url: string;
  icon: typeof LayoutDashboard;
  disabled?: boolean;
  adminOnly?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  // AUT-245 §1: Brand Intelligence is the primary page; `/` redirects here (App.tsx)
  // and Brand Overview is removed from the nav. The Dashboard route still exists.
  { title: "Brand Intelligence", url: RoutePath.BrandIntelligence, icon: Radar },
  { title: "Products", url: RoutePath.Products, icon: Package },
  { title: "Brand Signals", url: RoutePath.ABTests, icon: FlaskConical },
  { title: "Rank Tracker", url: RoutePath.RankTracker, icon: BarChart3 },
  // AUT-477: Keyword Trends moved out of this list into the sidebar footer. AUT-429 put it beside
  // Rank Tracker as market-wide keyword research; the design groups it with the other items that
  // are global rather than brand-scoped ("Keyword Trends — global, not brand-scoped",
  // signal-v3 `AppSidebar.tsx`). It now lives in `SidebarFooter`, between Portfolio Analytics and
  // Notifications.
  // AUT-26: per Linear thread, "visible for admin only, accessible by admin only".
  { title: "Brand Context", url: RoutePath.BrandContext, icon: BookOpen, adminOnly: true },
];

export const ICON_CLASS = "h-[22px] w-[22px] shrink-0";
export const ICON_CLASS_SM = "h-[18px] w-[18px] shrink-0";
const ITEM_BASE = "py-2.5 rounded-lg text-sidebar-foreground/80 hover:bg-black/15 hover:text-sidebar-foreground transition-colors";
export const EXPANDED_ITEM = `flex items-center gap-3 px-3 ${ITEM_BASE}`;
export const COLLAPSED_ITEM = `flex items-center justify-center ${ITEM_BASE}`;
